import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app"
const firebaseConfig = {
    apiKey: "AIzaSyAycxWWGIYMWvrK0_vKJwVkTcNGxcCfnyA",
    authDomain: "react-firebase-liveimmortal.firebaseapp.com",
    projectId: "react-firebase-liveimmortal",
    storageBucket: "react-firebase-liveimmortal.appspot.com",
    messagingSenderId: "967480164090",
    appId: "1:967480164090:web:2b7d5707d22b6f83799343",
    measurementId: "G-KE4LW8JL13"
  };


  const app = initializeApp(firebaseConfig);

  export const firebaseAuth = getAuth(app);